import React, { FunctionComponent, useEffect } from "react";
import { FieldValues, useFieldArray, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { getPestDetail, updatePestDetail } from "../../services";
import { UpdatePestInput } from "../../types/api";
import { PestForm } from "./form";

export const PestDetailWithID: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { handleSubmit, control, setValue, watch } = useForm();
  const { fields, append, swap, remove } = useFieldArray({
    name: "image_url",
    control
  });
  const { id } = useParams();
  useEffect(() => {
    getPestDetail({ id, append, setValue, dispatch });
  }, [id, append, setValue, dispatch]);

  const onSubmit = async (data: FieldValues) => {
    const pestData: UpdatePestInput = {
      id: data.id,
      name: data.name,
      description: data.description,
      detection: data.detection,
      management: data.management,
      notes: data.notes,
      image_url: data.image_url
    };
    updatePestDetail({ pestData, dispatch });
  };

  return (
    <PestForm
      onSubmit={onSubmit}
      handleSubmit={handleSubmit}
      image_field={fields}
      image_append={append}
      image_swap={swap}
      image_remove={remove}
      setValue={setValue}
      watch={watch}
      created
    />
  );
};
